import qs from "qs";
import { baseUrl, basePlatform, appVersion } from "../config/env.js";
import { creatOrderFactory } from "@/utils/superpay";
import { cryptoHttp } from "./servieHelpers";
import { jumpWebPayPalQueryFactory } from "./paypal";

export const payByCard = (
  dataJson //通过信用卡的web购买
) => {
  //如果传过来的dataJson包含email这个字段，就需要添加stripe_email来进行订阅支付
  if (dataJson.hasOwnProperty("email")) {
    return cryptoHttp.post(
      baseUrl + "/mobile/post_offer",
      qs.stringify({
        offer_id: dataJson.offer_id,
        user_info: JSON.stringify(dataJson.user_info),
        feed_data: JSON.stringify(dataJson.feed_data),
        offer_platform: dataJson.offer_platform,
        primary_platform: dataJson.primary_platform,
        receipt: JSON.stringify({
          stripe_token: dataJson.receipt,
          stripe_email: dataJson.email
        }),
        mver: dataJson.hasOwnProperty("mver") ? dataJson.mver : ""
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
  } else {
    return cryptoHttp.post(
      baseUrl + "/mobile/post_offer",
      qs.stringify({
        offer_id: dataJson.offer_id,
        user_info: JSON.stringify(dataJson.user_info),
        feed_data: JSON.stringify(dataJson.feed_data),
        offer_platform: dataJson.offer_platform,
        primary_platform: dataJson.primary_platform,
        receipt: JSON.stringify({ stripe_token: dataJson.receipt }),
        mver: dataJson.hasOwnProperty("mver") ? dataJson.mver : ""
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
  }
};

/**
 * pay by web paypal 通过web二次跳转
 * @param {*} baseUrl
 */
export const payByWebPayPal = ({ baseUrl, offer }) => {
  try {
    console.log(
      "payByWebPayPal:",
      baseUrl + "?" + jumpWebPayPalQueryFactory(offer)
    );
    window.location.href = baseUrl + "?" + jumpWebPayPalQueryFactory(offer);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * ins media
 * @param {*} params
 */
export const insMedia = async params => {
  try {
    const result = await cryptoHttp.get(baseUrl + "/web/v1/i/user/medias", {
      params
    });
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * ins userinfo
 * @param {*} dataJson
 */
export const insUserInfo = async username => {
  try {
    const result = await cryptoHttp.get(baseUrl + "/web/v1/i/user/info", {
      params: {
        username
      }
    });
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * free followers
 * @param {*} dataJson
 */
export const freeDeliver = async dataJson => {
  try {
    const result = await cryptoHttp.post(
      baseUrl + "/web/v1/free/deliver",
      dataJson
    );
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const freeCheck = async (master_id, user_id) => {
  try {
    const result = await cryptoHttp.post(baseUrl + "/web/v1/free/check", {
      master_id: master_id,
      user_id: user_id,
      platform: basePlatform
    });
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * post offer
 * @param {*} postOfferData
 */
export const postOffer = async postOfferData => {
  try {
    const result = await cryptoHttp.post(
      baseUrl + "/web/v1/order/iap",
      postOfferData
    );
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * setting
 */
export const getSettingData = async () => {
  try {
    const result = await cryptoHttp.get(baseUrl + "/web/v1/settings/content", {
      params: {
        platform: basePlatform,
        app_version: appVersion,
        keys:
          "client_settings,sale,rewards,rate_task,checkin_rewards,follow_offers,golden_follow_offers,like_offers,comment_offers,view_offers,story_offers,special_follow_offers,special_like_offers,auto_subs_follow_offers,auto_subs_like_offers,coin_offers,limited_coin_offers,lucky_coin_offers,half_coin_offers,feed_coin_offers,service_offers,vip_package_offers,casino,pro_extra_percentage,free_followers_for_newbie_enabled"
      }
    });
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * 获取service list
 * @param {*} master_id
 */
export const getServiceList = async master_id => {
  try {
    const result = await cryptoHttp.get(baseUrl + "/web/v1/services/list", {
      params: {
        master_id,
        platform: basePlatform
      }
    });
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * login gx
 * @param {*} master_id
 */
export const loginByMasterId = async (master_id, user_id) => {
  try {
    const result = await cryptoHttp.post(baseUrl + "/web/v1/user/login", {
      platform: basePlatform,
      user_info: {
        master_id,
        user_id
      },
      app_version: "1.2.0"
    });
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * creat order
 * @param {*} creatOrderData
 */
export const createOrder = async creatOrderData => {
  try {
    const result = await cryptoHttp.post(
      baseUrl + "/web/v1/order/create",
      creatOrderFactory(creatOrderData)
    );
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * 获取订单的状态
 * @param {*} transaction_id
 */
export const getOrderReceipt = async transaction_id => {
  try {
    const result = await cryptoHttp.get(baseUrl + "/web/v1/order/info", {
      params: { transaction_id }
    });
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};



// WEBPACK FOOTER //
// ./src/service/service.js